export default function getSummaries (param, sumsArr, fixed) {
  if (fixed === undefined || fixed == null) fixed = 10
  const { columns, data } = param
  const sums = []
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '合计'
      return
    }
    const values = data.map((item) => Number(item[column.property]))
    sumsArr.forEach(item => {
      if (column.property === item) {
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return Number((prev + curr).toFixed(fixed))
          } else {
            return prev
          }
        }, 0)
      }
    })
  })
  return sums
}
